module.exports = __webpack_public_path__ + "media/images/flags/4x3/uga-463f178dfb397cc94a9e475931a882f7.svg";